import type { LinkRect } from './types'

export const PREVIEW_WIDTH = 322
export const PREVIEW_OFFSET_Y = 12
export const VIEWPORT_PADDING = 16

export interface PreviewPosition {
  top?: number
  bottom?: number
  left: number
}

/**
 * Calculate the fixed position for a hover preview relative to a link/marker rect.
 *
 * Places the preview below the link when there is enough room, otherwise above.
 * When neither direction fully fits, the side with more space wins.
 *
 * @param linkRect – bounding rect of the trigger element
 * @param estimatedPreviewHeight – approximate height of the preview card
 */
export function calculatePreviewPosition(
  linkRect: LinkRect,
  estimatedPreviewHeight: number,
): PreviewPosition {
  const viewportHeight = window.innerHeight
  const viewportWidth = window.innerWidth

  let left = linkRect.left + linkRect.width / 2 - PREVIEW_WIDTH / 2
  left = Math.max(VIEWPORT_PADDING, Math.min(left, viewportWidth - PREVIEW_WIDTH - VIEWPORT_PADDING))

  const spaceBelow = viewportHeight - linkRect.bottom
  const spaceAbove = linkRect.top

  if (spaceBelow >= estimatedPreviewHeight + PREVIEW_OFFSET_Y) {
    return { top: linkRect.bottom + PREVIEW_OFFSET_Y, left }
  }

  if (spaceAbove >= estimatedPreviewHeight + PREVIEW_OFFSET_Y) {
    return { bottom: viewportHeight - linkRect.top + PREVIEW_OFFSET_Y, left }
  }

  // Neither direction fully fits — pick whichever side has more room
  if (spaceAbove > spaceBelow) {
    return { bottom: viewportHeight - linkRect.top + PREVIEW_OFFSET_Y, left }
  }
  return { top: linkRect.bottom + PREVIEW_OFFSET_Y, left }
}
